import _ from 'lodash';

import { bindServices } from '@/services/api';

const api = bindServices('lists');
import { toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';
import { updateFavorite } from './service';
import { filtersConfig } from './utils';
import { groupsFiltersConfig } from './manage-groups/utils';

import './utils';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const initialState = {
  data: [],
  groups: [],
  favorites: [],
  currentGroup: {},
  searchCriteria: '',
  listPagination: meta,
  groupsPagination: meta,
  orderBy: '',
  filtersConfig,
  groupsFiltersConfig,
  favoritesChanged: false,
};

const Model = {
  namespace: 'lists',
  state: initialState,
  effects: {
    *fetchGroups({ payload }, { call, put }) {
      try {
        const params = {
          route: 'list/groups',
          ...CoreQueries.ManageLists.groups,
          ...payload,
        };

        const res = yield call(api.getAll, params);

        yield put({
          type: 'queryGroups',
          payload: {
            ...res,
            ..._.pick(payload, ['page', 'limit']),
          },
        });
      } catch (e) {}
    },

    *fetchLists({ payload }, { call, put }) {
      try {
        const params = {
          route: 'list/allowed',
          ...CoreQueries.ManageLists.paged,
          ...payload,
        };

        const res = yield call(api.getAll, params);

        yield put({
          type: 'queryList',
          payload: {
            ...res,
            ..._.pick(payload, ['page', 'limit']),
          },
        });
      } catch (e) {}
    },

    *fetchFavorites({ payload }, { call, put }) {
      try {
        const params = {
          route: 'list/favorites',
          ...CoreQueries.ManageLists.favorites,
          ...payload,
        };
        const res = yield call(api.getAll, params);
        yield put({ type: 'queryFavorites', payload: res });
      } catch (e) {}
    },

    *setFavorite({ payload }, { call, put }) {
      try {
        yield call(updateFavorite, payload);
        yield put({ type: 'querySetFavorite', payload });

        yield put({ type: 'markFavoritesChanged' });
      } catch (e) {}
    },

    *search({ payload }, { put }) {
      yield put({ type: 'querySearch', payload });
    },

    *onTabChange({ payload }, { put, select }) {
      if (payload === 'favorites') {
        const { favoritesChanged } = yield select((state) => state.lists);
        if (favoritesChanged) {
          yield put({ type: 'fetchFavorites', payload: { page: 1 } });
          yield put({ type: 'clearFavoritesChanged' });
        }
      }
    },

    *paginate({ payload }, { put }) {
      yield put({ type: 'queryPage', payload });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({ type: 'orderBy', payload });
    },

    *deleteItem({ id, params }, { call, put }) {
      try {
        yield call(api.apiRoute, {
          route: `customList/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'queryDeleteItem',
          payload: { id },
        });
        yield put({
          type: 'fetchLists',
          payload: { ...params, readPriority: true },
        });
      } catch (e) {}
    },

    *toggleActive({ payload }, { call, put }) {
      try {
        yield call(api.apiRoute, {
          route: `customList/activate/${payload.id}/${payload.isActive}`,
          method: 'post',
        });
        yield put({
          type: 'queryToggleActive',
          payload: { id: payload.id, isActive: payload.isActive },
        });
      } catch (e) {}
    },

    *reset(o, { put }) {
      yield put({ type: 'resetState' });
    },
  },
  reducers: {
    queryGroups(state, { payload }) {
      return {
        ...state,
        groups: payload?.items || [],
        groupsPagination: {
          ...state.groupsPagination,
          ...payload,
          ...toPaginate(payload),
        },
      };
    },

    queryList(state, { payload }) {
      return {
        ...state,
        data: payload?.items || [],
        listPagination: {
          ...state.listPagination,
          ...payload,
          ...toPaginate(payload),
        },
      };
    },

    queryFavorites(state, { payload }) {
      return {
        ...state,
        favorites: payload,
      };
    },

    querySetFavorite(state, { payload }) {
      return {
        ...state,
        data: state.data.map((item) =>
          item.id === payload.id ? { ...item, isFavorite: !payload.isFavorite } : item,
        ),
        favorites: payload.isFavorite
          ? state.favorites.filter((item) => item.id !== payload.id)
          : state.favorites,
      };
    },

    markFavoritesChanged(state) {
      return {
        ...state,
        favoritesChanged: true,
      };
    },

    clearFavoritesChanged(state) {
      return {
        ...state,
        favoritesChanged: false,
      };
    },

    querySearch(state, { payload }) {
      return {
        ...state,
        ...(_.isString(payload) && { searchCriteria: payload }),
        ...(_.isObject(payload) && {
          [`search${_.capitalize(payload.viewContext)}Criteria`]: payload.criteria,
        }),
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    queryDeleteItem(state, { payload }) {
      return {
        ...state,
        data: state.data.filter((item) => item.id !== payload.id),
      };
    },

    queryToggleActive(state, { payload }) {
      return {
        ...state,
        data: state.data.map((item) =>
          item.id === payload.id ? { ...item, isActive: payload.isActive } : item,
        ),
        favorites: state.favorites.map((item) =>
          item.id === payload.id ? { ...item, isActive: payload.isActive } : item,
        ),
      };
    },

    resetState() {
      return initialState;
    },
  },
};

export default Model;
